import { forwardRef, memo } from 'react';
import cn from 'classnames';
import { InputLayout } from './input-layout';

type SelectProps = {
   label?: React.ReactNode;
   labelClassName?: string;
   error?: React.ReactNode;
   valid?: React.ReactNode;
   groupClassName?: string;
   name?: string;
   disabled?: boolean;
   autoComplete?: string;
   inputWrapperClassName?: string;
   value?: string;
   description?: React.ReactNode;
} & React.HTMLAttributes<HTMLSelectElement>;

const Select = forwardRef<HTMLSelectElement, SelectProps>(
   (
      {
         label,
         description,
         error,
         groupClassName,
         children,
         labelClassName,
         valid,
         id,
         className,
         ...props
      },
      ref
   ) => {
      return (
         <InputLayout
            description={description}
            error={error}
            groupClassName={groupClassName}
            label={label}
            labelClassName={labelClassName}
            valid={valid}
            id={id}>
            <select id={id} ref={ref} className={cn('input', className)} {...props}>
               {children}
            </select>
         </InputLayout>
      );
   }
);
Select.displayName = `Select`;
export default memo(Select);
